import { Figure } from "../Figure";
import { BEA, BEA_HQ_PHOTO } from "../../lib/bea";

export function AboutBEA() {
  return (
    <section className="section" id="about">
      <div className="container about-grid">
        <div className="reveal">
          <div className="kicker">Bapuji Educational Association</div>
          <h2>Empowering generations through {BEA.institutions} institutions in education since {BEA.founded}.</h2>
          <p
            style={{
              color: "var(--text-soft)",
              marginTop: 18,
              fontSize: 17,
              lineHeight: 1.7,
            }}
          >
            With a legacy spanning over six decades, Bapuji Educational Association stands as a
            beacon of holistic education in Karnataka. It runs more than 60 institutions — nursery
            through postgraduate, spanning engineering, medicine, dentistry, pharmacy and nursing.
          </p>
          <p
            style={{
              color: "var(--text-soft)",
              marginTop: 14,
              fontSize: 17,
              lineHeight: 1.7,
            }}
          >
            That breadth is what earned Davanagere its name as the Oxford of Karnataka. BIET has
            been the association's engineering college since 1979.
          </p>
          <a
            className="btn-link"
            href="https://bapujidvg.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: 24 }}
          >
            Read more <span className="arr">→</span>
          </a>
        </div>
        <div className="reveal">
          <Figure
            media={BEA_HQ_PHOTO}
            fallbackLabel="BEA HEADQUARTERS · DAVANAGERE"
            aspect="4/3"
            sizes="(max-width: 900px) 92vw, 44vw"
          />
        </div>
      </div>
    </section>
  );
}
